import { render } from "./ComHeader.vue?vue&type=template&id=14ea7d06"
import script from "./ComHeader.vue?vue&type=script&lang=js"
export * from "./ComHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__